import { StringParam, useQueryParam, withDefault } from 'use-query-params';
import { GetUrlParams, PAGINATION_PARAMS } from '@lib/enums/urls';
import usePaginationParams from '@lib/hooks/usePaginationParams';

function useTabParam({
  allowedTabs,
  defaultTab,
  defaultPaginationParams,
  usePagination = true,
}:
  | {
      // `tab` is shared by every list page. On navigation the outgoing page
      // can re-render once with the destination's tab (e.g. /tasks seeing
      // `tab=OPENED` on its way to /interventions) and fire its query with a
      // foreign scope. Values outside this list resolve to `defaultTab`.
      allowedTabs?: readonly string[];
      defaultTab?: string;
      defaultPaginationParams?: object;
      usePagination?: boolean;
    }
  | undefined = {}) {
  const [rawTabParam, setTabParam] = useQueryParam(
    GetUrlParams.Tab,
    withDefault(StringParam, defaultTab),
  );
  const tabParam =
    allowedTabs && rawTabParam && !allowedTabs.includes(rawTabParam)
      ? defaultTab
      : rawTabParam;
  const [, setPaginationParams] = usePaginationParams();
  const onSetTabParam = (v: string, paginationParams?: object) => {
    setTabParam(v);
    if (usePagination) {
      setPaginationParams({
        ...(paginationParams || defaultPaginationParams || PAGINATION_PARAMS),
        [GetUrlParams.Page]: '1',
      });
    }
  };
  return [tabParam, onSetTabParam] as const;
}

export default useTabParam;
